export const FIRST_DAY_OF_THE_WEEK = 1;
export const DATE_TIME_PICKER_YEARS_BEFORE = 0;
export const DATE_TIME_PICKER_YEARS_AFTER = 3;
export const DATE_DISPLAY_FORMAT = 'dd/MM/yyyy';
